var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvalidToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 71,
    viewBox: "0 0 193 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0274 13.8994H37.6982V71.0001H39.0274V13.8994Z",
    fill: "#07127D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0844 25.5084L48.1445 24.5781L38.051 34.5687L38.9909 35.499L49.0844 25.5084Z",
    fill: "#07127D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7564 35.4986L38.6963 34.5684L28.6028 24.5778L27.6629 25.5081L37.7564 35.4986Z",
    fill: "#07127D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0844 38.7906L48.1445 37.8604L38.051 47.8509L38.9909 48.7812L49.0844 38.7906Z",
    fill: "#07127D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7564 48.7819L38.6963 47.8516L28.6028 37.861L27.6629 38.7913L37.7564 48.7819Z",
    fill: "#07127D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6662 0H72.2246V11.8161H89.6662V0Z",
    fill: "#6A76F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5615 0H71.125V11.6334H80.5615V0Z",
    fill: "#07127D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.367 0H96.9258V11.8161H114.367V0Z",
    fill: "#6A76F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.502 70.9998H92.5342V29.5239L104.744 11.6431H121.295L132.502 29.5239V70.9998Z",
    fill: "#6A76F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 11.6431H64.2495L52.7207 29.5239V70.9998H92.6888V29.5239H92.5342L105.263 11.6431Z",
    fill: "#07127D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 0H95.8262V11.6334H105.263V0Z",
    fill: "#07127D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.652 17.0767L47.0869 36.1074L51.1787 53.9209L135.744 34.8902L131.652 17.0767Z",
    fill: "#D2D4FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3974 40.31C88.9279 40.6405 89.6844 40.4703 90.0183 39.9452C90.3523 39.4201 90.1803 38.6714 89.6498 38.3408C89.1193 38.0103 88.3629 38.1805 88.0289 38.7056C87.6949 39.2307 87.8669 39.9794 88.3974 40.31ZM87.3225 35.6305C87.8531 35.9611 88.6095 35.7909 88.9435 35.2658C89.2774 34.7406 89.1054 33.9919 88.5749 33.6614C88.0444 33.3308 87.288 33.501 86.954 34.0261C86.62 34.5513 86.792 35.3 87.3225 35.6305Z",
    fill: "#07127D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5644 29.3046C91.3901 29.9063 91.268 30.4259 91.1814 30.8531C91.0949 31.2804 91.0587 31.865 91.0729 32.6071C91.0871 33.3491 91.1811 34.1294 91.3746 34.9717C91.5681 35.814 91.8272 36.5713 92.1386 37.2464C92.4499 37.9216 92.738 38.4333 93.0026 38.7815C93.2673 39.1297 93.6013 39.5326 94.0213 40.0005L95.4666 39.6753C94.8698 38.994 94.3644 38.2782 93.9775 37.5216C93.5906 36.765 93.2688 35.7969 92.9955 34.607C92.5195 32.5346 92.5298 30.6622 93.0098 28.9794L91.5644 29.3046Z",
    fill: "#07127D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154.426 13.8994H153.097V71.0001H154.426V13.8994Z",
    fill: "#07127D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.271 58.3444L113.331 57.4141L106.308 64.3659L107.247 65.2962L114.271 58.3444Z",
    fill: "#07127D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.7 65.298L107.64 64.3677L100.616 57.4158L99.6763 58.3461L106.7 65.298Z",
    fill: "#07127D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.638 56.8711H106.309V71H107.638V56.8711Z",
    fill: "#07127D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.484 25.5089L163.544 24.5786L153.45 34.5692L154.39 35.4994L164.484 25.5089Z",
    fill: "#07127D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.155 35.4991L154.095 34.5688L144.001 24.5783L143.061 25.5086L153.155 35.4991Z",
    fill: "#07127D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M164.484 38.7911L163.544 37.8608L153.45 47.8514L154.39 48.7817L164.484 38.7911Z",
    fill: "#07127D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.155 48.7819L154.095 47.8516L144.001 37.861L143.061 38.7913L153.155 48.7819Z",
    fill: "#07127D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.172 32.3208H9.84277V71.0001H11.172V32.3208Z",
    fill: "#07127D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4233 36.4298L20.4834 35.4995L10.3899 45.4901L11.3298 46.4204L21.4233 36.4298Z",
    fill: "#07127D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0933 46.4225L11.0332 45.4922L0.939706 35.5017L-0.000167735 36.4319L10.0933 46.4225Z",
    fill: "#07127D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4233 49.712L20.4834 48.7817L10.3899 58.7723L11.3298 59.7026L21.4233 49.712Z",
    fill: "#07127D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0933 59.7047L11.0332 58.7744L0.939705 48.7839L-0.000168466 49.7142L10.0933 59.7047Z",
    fill: "#07127D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M182.75 29.3984H181.421V68.0777H182.75V29.3984Z",
    fill: "#07127D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192.999 33.5065L192.06 32.5762L181.966 42.5667L182.906 43.497L192.999 33.5065Z",
    fill: "#07127D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M181.672 43.4952L182.612 42.5649L172.519 32.5744L171.579 33.5047L181.672 43.4952Z",
    fill: "#07127D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M192.999 46.7887L192.06 45.8584L181.966 55.8489L182.906 56.7792L192.999 46.7887Z",
    fill: "#07127D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M181.672 56.7779L182.612 55.8477L172.519 45.8571L171.579 46.7874L181.672 56.7779Z",
    fill: "#07127D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M125.235 70.9999C125.235 66.8802 128.609 63.5405 132.772 63.5405C136.934 63.5405 140.308 66.8802 140.308 70.9999",
    fill: "#07127D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M119.168 70.9998C119.168 68.2427 121.427 66.0063 124.213 66.0063C126.998 66.0063 129.258 68.2427 129.258 70.9998",
    fill: "#07127D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M135.747 70.9998C135.747 68.2427 138.006 66.0063 140.792 66.0063C143.578 66.0063 145.837 68.2427 145.837 70.9998",
    fill: "#07127D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5234 70.9999C51.5234 66.8802 54.8975 63.5405 59.0597 63.5405C63.2218 63.5405 66.5959 66.8802 66.5959 70.9999",
    fill: "#6A76F6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4561 70.9998C45.4561 68.2427 47.7154 66.0063 50.501 66.0063C53.2866 66.0063 55.546 68.2427 55.546 70.9998",
    fill: "#6A76F6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0322 70.9998C62.0322 68.2427 64.2916 66.0063 67.0772 66.0063C69.8628 66.0063 72.1221 68.2427 72.1221 70.9998",
    fill: "#6A76F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidToken);
export default __webpack_public_path__ + "static/media/invalid_token.50de3cf3.svg";
export { ForwardRef as ReactComponent };